export default __webpack_public_path__ + "navigation-examples-embedded-navigation-thumbnail-960-46e13e3d91c46f809b59e13482b10c1c.webp";